var _defs, _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#214080;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.11,8.95c-.59-2.51-2.86-4.37-5.59-4.53-.69,.04-2.46,.28-3.95,1.7-1.59,1.51-1.88,3.4-1.92,4.18l-1.71,2.64c-.1,.16-.13,.36-.06,.54l.16,.3,1.39,.43v2.12c0,.58,.47,1.06,1.06,1.06h2.28l-.04,2.45h6.5l-.03-5.1c1.68-1.47,2.41-3.69,1.92-5.78Zm-2.58,5.03c-.2,.17-.31,.42-.31,.67v4.18h-4.49l.03-1.6c0-.23-.08-.44-.24-.6-.16-.16-.37-.25-.6-.25l-2.49-.06v-2.41c0-.27-.17-.5-.43-.58l-.94-.29,1.45-2.24c.08-.12,.13-.26,.13-.42,.03-.64,.26-2.26,1.62-3.55,1.25-1.19,2.74-1.39,3.26-1.43,2.23,.13,4.13,1.67,4.61,3.76,.41,1.73-.21,3.58-1.61,4.8Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.64,6.54c-.8-.09-1.65,.3-2.19,1.02-.56,.75-.57,1.81-.02,2.66,.1,.16,.21,.32,.31,.46h0s.05,.09,.05,.14v1.37h3.22v-1.44s.01-.08,.03-.11l.29-.45c.47-.73,.53-1.63,.14-2.34-.4-.73-1.08-1.22-1.84-1.31Zm.86,3.11l-.29,.45c-.13,.19-.19,.42-.19,.65v.44h-1.22v-.37c0-.26-.09-.51-.25-.73-.09-.13-.19-.27-.29-.43-.32-.48-.32-1.09-.01-1.5,.33-.43,.82-.68,1.28-.63,.42,.05,.83,.35,1.07,.79,.21,.39,.17,.91-.1,1.33Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 9,
    y: 12.38,
    width: 2.78,
    height: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4.48,
    y: 2.44,
    width: 1,
    height: 2.96,
    transform: "translate(-1.36 4.11) rotate(-39.89)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 6.98,
    y: 0.97,
    width: 1,
    height: 3.06,
    transform: "translate(-.39 2.95) rotate(-21.73)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 9.88,
    y: 0.43,
    width: 1,
    height: 3.04
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 11.74,
    y: 1.97,
    width: 3.09,
    height: 1,
    transform: "translate(6.41 14.11) rotate(-69.95)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 14.48,
    y: 3.32,
    width: 2.85,
    height: 1,
    transform: "translate(2.78 13.58) rotate(-50.15)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon6);
export default __webpack_public_path__ + "static/media/icon6.50fcb97edfd7d2a44623cc5bacc40dcf.svg";
export { ForwardRef as ReactComponent };